import { Theme, makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import { LoginControl } from '../login/LoginControl';

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    paddingTop: theme.spacing(2),
  },
  logo: {
    height: '60px'
  },
}));

export function Header() {
  const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <AppBar color='primary' position='static' elevation={0} className={classes.appBar}>
      <Toolbar>
        <Grid container spacing={1} alignItems="center">
          <Grid item>
            <img src={`${baseUrl}logo.png`} alt='APRU VSE logo' className={classes.logo} />
          </Grid>
          <Grid item xs />
          <Grid item>
            <LoginControl />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}
